module.exports = __webpack_public_path__ + "img/shirt.e756430d.png";